import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

function toDateMaybe(v) {
  if (!v) return null;
  if (v instanceof Date) return v;
  if (typeof v?.toDate === 'function') {
    try { return v.toDate(); } catch { return null; }
  }
  if (typeof v === 'number') return new Date(v);
  if (typeof v === 'string') {
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

function formatRemaining(ms) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  return hours > 0 ? `${hours}:${mm}:${ss}` : `${minutes}:${ss}`;
}

export default function Maintenance({ message, endsAt, updatedAt, updatedBy, initiatedBy }) {
  const endsAtDate = useMemo(() => toDateMaybe(endsAt), [endsAt]);
  const updatedAtDate = useMemo(() => toDateMaybe(updatedAt), [updatedAt]);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!endsAtDate) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [endsAtDate]);

  const remainingMs = endsAtDate ? endsAtDate.getTime() - now : null;
  const remainingLabel = remainingMs != null ? formatRemaining(remainingMs) : null;
  const isOverdue = remainingMs != null && remainingMs <= 0;

  return (
    <div className="maintenance-shell">
      <div className="maintenance-center">
        <div className="glass-card maintenance-card" style={{ width: '100%', maxWidth: 900, padding: 20, textAlign: 'center' }}>
        <h1 className="card-title" style={{ marginTop: 0 }}>Maintenance Mode</h1>
        <p className="subtitle" style={{ marginTop: 8 }}>
          The site is temporarily disabled.
        </p>

        {endsAtDate ? (
          <div className="maintenance-timer" aria-live="polite">
            <div className="maintenance-timer-label">
              {isOverdue ? 'Expected back any moment' : 'Expected back in'}
            </div>
            <div className="maintenance-timer-value">
              {isOverdue ? '0:00' : remainingLabel}
            </div>
            <div className="meta-text" style={{ marginTop: 6 }}>
              {endsAtDate.toLocaleString()}
            </div>
          </div>
        ) : null}

        {message ? (
          <div className="glass-card" style={{ marginTop: 16, padding: 16, textAlign: 'left' }}>
            <div className="meta-text" style={{ marginBottom: 6, opacity: 0.8 }}>Reason</div>
            <div style={{ whiteSpace: 'pre-wrap' }}>{message}</div>
          </div>
        ) : null}
        <div className="meta-text" style={{ marginTop: 16, opacity: 0.8 }}>
          Please check back soon.
        </div>

        {(updatedAtDate || initiatedBy) ? (
          <div className="meta-text" style={{ marginTop: 10, opacity: 0.7 }}>
            {updatedAtDate ? `Updated: ${updatedAtDate.toLocaleString()}` : null}
            {updatedAtDate && initiatedBy ? ' • ' : null}
            {initiatedBy ? `Initiated by: ${initiatedBy}` : null}
          </div>
        ) : null}

        <div style={{ marginTop: 18 }}>
          <Link to="/login" className="nav-link">Admin Login</Link>
        </div>
        </div>
      </div>
    </div>
  );
}
